export { SubmissionError, SubmissionResult, SubmissionTypes } from './submission-result.model';
export {
  FlatFormControlsForm,
  FlatFormGroup,
  FormGroupControls,
  FormGroupValue,
  NonGroup,
  TypedControlsIn,
  TypedFormArray,
  TypedFormGroup,
} from './typed-form';

export enum FormActionTypes {
  ValidateAndSubmit,
}
